// extracted by mini-css-extract-plugin
module.exports = {"container":"FoodsStartShift_container__2mAb2","icon":"FoodsStartShift_icon__3Kplr"};